import './VehicleHeader.css';const vehicleHeader = "_vehicleHeader_1tdll_1";
const styles = {
  vehicleHeader
};
export {
  styles as default,
  vehicleHeader
};
